import { render } from "./HeaderLogin.vue?vue&type=template&id=53970ea6&scoped=true"
import script from "./HeaderLogin.vue?vue&type=script&lang=js"
export * from "./HeaderLogin.vue?vue&type=script&lang=js"

import "./HeaderLogin.vue?vue&type=style&index=0&id=53970ea6&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53970ea6"]])

export default __exports__